import { useEffect, useState } from "react";

export type Theme = "light" | "dark";
export type Style = "standard" | "neo" | "glass";

export function getTheme(): Theme {
  const stored = localStorage.getItem("ndis.theme");
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
export function getStyle(): Style {
  const stored = localStorage.getItem("ndis.style");
  return stored === "neo" || stored === "glass" ? stored : "standard";
}

export function applyAppearance(theme: Theme, style: Style): void {
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  root.dataset.style = style;
  localStorage.setItem("ndis.theme", theme);
  localStorage.setItem("ndis.style", style);
}

export function useAppearance() {
  const [theme, setTheme] = useState<Theme>(getTheme);
  const [style, setStyle] = useState<Style>(getStyle);
  useEffect(() => applyAppearance(theme, style), [theme, style]);
  return {
    theme, style, setStyle,
    toggleTheme: () => setTheme((t) => (t === "dark" ? "light" : "dark")),
  };
}

/** Back-compat for Layout's toggle. */
export function useTheme(): [Theme, () => void] {
  const { theme, toggleTheme } = useAppearance();
  return [theme, toggleTheme];
}
